import { render, staticRenderFns } from "./BeeAccountLabel.vue?vue&type=template&id=ba0a3a3c&scoped=true"
import script from "./BeeAccountLabel.vue?vue&type=script&lang=js"
export * from "./BeeAccountLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba0a3a3c",
  null
  
)

export default component.exports